import { TranslationKey } from './../translation/TranslationKey';
import { CustomFieldEntitySubType } from '../custom_field/customField';
import { ProductTransactionSpecifiers } from '../productTransaction';
import { translate } from '../translation/Translator';
import { Order } from './order';
import { PdfTemplateEntitySubtype } from '../pdf_template';
import { FlowType } from './orderFlow';
import { OrderStatus } from './orderStatus';

export namespace OrderUtil {
  export const SAP_IDENTIFIER = '001';

  export function hasToStockLocation(order: Order): boolean {
    switch (order.type) {
      case FlowType.inbound:
      case FlowType.replenish:
      case FlowType.move:
        return true;
      case FlowType.outbound:
      case FlowType.disposal:
        return false;
    }
  }

  export function hasFromStockLocation(order: Order): boolean {
    switch (order.type) {
      case FlowType.inbound:
      case FlowType.replenish:
        return false;
      case FlowType.outbound:
      case FlowType.move:
      case FlowType.disposal:
        return true;
    }
  }

  export function determineStockLocation(order: Order): string {
    switch (order.type) {
      case FlowType.inbound:
      case FlowType.replenish:
        return order.toStockLocationId!;
      case FlowType.outbound:
      case FlowType.move:
      case FlowType.disposal:
        return order.fromStockLocationId!;
    }
  }

  export function orderSpecifierHash(specifier: ProductTransactionSpecifiers) {
    return orderSpecifierHashByValue(
      specifier.pmdId,
      specifier.containerId || specifier.toContainerId || specifier.fromContainerId,
    );
  }

  export function orderSpecifierHashByValue(pmdId?: string, containerId?: string) {
    return `${pmdId || ''}|${containerId || ''}`;
  }

  export const typeToString = (type: FlowType) => {
    switch (type) {
      case FlowType.inbound:
        return translate({ key: TranslationKey.inbound });
      case FlowType.outbound:
        return translate({ key: TranslationKey.outbound });
      case FlowType.disposal:
        return translate({ key: TranslationKey.disposal });
      case FlowType.replenish:
        return translate({ key: TranslationKey.replenish });
      case FlowType.move:
        return translate({ key: TranslationKey.move });
    }
  };

  export const typeToEntitySubType = (type: FlowType): CustomFieldEntitySubType => {
    switch (type) {
      case FlowType.inbound:
        return CustomFieldEntitySubType.inbound;
      case FlowType.outbound:
        return CustomFieldEntitySubType.outbound;
      case FlowType.replenish:
        return CustomFieldEntitySubType.replenish;
      case FlowType.move:
        return CustomFieldEntitySubType.move;
      case FlowType.disposal:
        return CustomFieldEntitySubType.disposal;
    }
  };

  export const statusToString = (status: string): string => {
    return status;
  };

  export const statusToColorStyle = (status: OrderStatus) => {
    return status.color;
  };

  export const orderTypeToPdfTemplateEntitySubtype = (type: FlowType): PdfTemplateEntitySubtype => {
    switch (type) {
      case FlowType.inbound:
      case FlowType.replenish:
        return PdfTemplateEntitySubtype.inbound;
      case FlowType.outbound:
        return PdfTemplateEntitySubtype.outbound;
      case FlowType.move:
        return PdfTemplateEntitySubtype.move;
      case FlowType.disposal:
        return PdfTemplateEntitySubtype.disposal;
    }
  };
}
